// extracted by mini-css-extract-plugin
module.exports = {"comments":"bb_fh","comments__list":"bb_fj"};